import { useLiveQuery } from 'dexie-react-hooks';
import { useWorkspace } from '@/app/providers/workspace-provider';
import type { FollowUpLog, SupervisorReminder, Uuid } from '@/data/db';

export function useFollowUpLogs(taskId: Uuid | null): FollowUpLog[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(async () => {
    if (!taskId) return [];
    const logs = await db.followUpLogs.where('taskId').equals(taskId).toArray();
    return logs
      .filter((log) => log.deletedAt === null)
      .sort((a, b) => a.occurredAtLocal.localeCompare(b.occurredAtLocal));
  }, [db, taskId]);
}

export function useSupervisorReminders(taskId: Uuid | null): SupervisorReminder[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(async () => {
    if (!taskId) return [];
    const reminders = await db.supervisorReminders.where('taskId').equals(taskId).toArray();
    return reminders.sort((a, b) => a.remindAtLocal.localeCompare(b.remindAtLocal));
  }, [db, taskId]);
}

/** 所有任務的提醒；今日桌面與提醒中心用。 */
export function useAllSupervisorReminders(): SupervisorReminder[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(() => db.supervisorReminders.toArray(), [db]);
}

export function useAllFollowUpLogs(): FollowUpLog[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(() => db.followUpLogs.toArray(), [db]);
}
